import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.css';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  // Définir les noms conviviaux pour chaque route
  const breadcrumbNames = {
    '': 'Accueil',
    'a-propos-de-nous': 'À propos de nous',
    'inscription': 'Inscription',
    'contact': 'Contact',
    'blog': 'Blog',
    'formations': 'Académie',
    'entreprises': 'Entreprise',
    'conduite-projet': 'Conduite projet',
    'diagnostic-projets': 'Diagnostic projet',
    'controle-projet': 'Controle projet',
    'pourquoi-nous': 'Pourquoi-nous ?',
    'contactez-nous': 'Contactez-nous'
  };

  return (
    <div className="breadcrumb-container">
      <nav className="breadcrumb" aria-label="Fil d'Ariane">
        <ol className="breadcrumb-list">
          <li className="breadcrumb-item">
            <Link to="/" className="breadcrumb-link">
              Accueil
            </Link>
            
          </li>
          
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            const displayName = breadcrumbNames[name] || name.replace(/-/g, ' ');

            return (
              <li key={name} className="breadcrumb-item">
                {isLast ? (
                  <span 
                    className="breadcrumb-current" 
                    aria-current="page"
                  >
                    {displayName}
                  </span>
                ) : (
                  <>
                    <Link to={routeTo} className="breadcrumb-link">
                      {displayName}
                    </Link>
                    {/* <span className="breadcrumb-separator">›</span> */}
                  </>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;